import { render, staticRenderFns } from "./EditRetailPartner.vue?vue&type=template&id=4576d322"
import script from "./EditRetailPartner.vue?vue&type=script&lang=js"
export * from "./EditRetailPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports